import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Spinner } from "reactstrap";
import {
  UserOutlined,
  ShopOutlined,
  BellOutlined,
  SlidersOutlined,
  InfoCircleOutlined,
  KeyOutlined
} from "@ant-design/icons";
import ProfileDetail from "./component/profile";
// import AppName from "./component/appName";
import "../utils/profileMenu.css";
import { AnimatePresence, motion } from "framer-motion";
import DoubleAuthSetting from "../../../common/authentificator/doubleAuthSetting";
import { useLocation } from "react-router-dom";

const ProfilePage = () => {
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab");
  
  const [activeTab, setActiveTab] = useState(initialTab === "doubleAuth" ? "Double authentification" : "Mon profil");
  const [isSwitching, setIsSwitching] = useState(false);

  const currentuser = JSON.parse(sessionStorage.getItem("authUser"));
  const username = currentuser?.username;

  

  const menuItems = [
    { key: "profile", label: "Mon profil", icon: <UserOutlined /> },
    // { key: "appToken", label: "App Token", icon: <ShopOutlined /> },
    { key: "doubleAuth", label: "Double authentification", icon: <KeyOutlined /> },
    { key: "notifications", label: "Notifications", icon: <BellOutlined /> },
    { key: "help", label: "Centre d’aide", icon: <InfoCircleOutlined /> },
  ];

  useEffect(() => {
    setIsSwitching(true);
    const timeout = setTimeout(() => {
      setIsSwitching(false);
    }, 100);
    return () => clearTimeout(timeout);
  }, [activeTab]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Mon profil":
        return <ProfileDetail currentuser={currentuser} />;
      // case "App Token":
      //   return <AppName currentuser={currentuser} />;
      case "Double authentification":
        return <DoubleAuthSetting currentuser={currentuser} username ={username}/>;
      default:
        return <div className="text-muted">Contenu à venir...</div>;
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={4}>
            <Card className="shadow-sm border-0 h-100">
              <CardBody className="p-0">
                <ul className="profile-menu-list">
                  {menuItems.map((item, index) => {
                    const isActive = item.label === activeTab;
                    return (
                      <li
                        key={index}
                        className={`profile-menu-item ${isActive ? "active" : ""}`}
                        onClick={() => setActiveTab(item.label)}
                      >
                        <span className={`icon ${isActive ? "text-active" : "text-muted"}`}>
                          {item.icon}
                        </span>
                        <span className={`label ${isActive ? "text-active" : ""}`}>
                          {item.label}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </CardBody>
            </Card>
          </Col>

          <Col lg={8}>
            <AnimatePresence mode="wait">
              {isSwitching ? (
                <motion.div
                  key="loading"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "300px" }}
                >
                  <Spinner color="primary" />
                </motion.div>
              ) : (
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  {renderActiveTab()}
                </motion.div>
              )}
            </AnimatePresence>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfilePage;
